import { useState, useEffect } from 'react';
import { getAttachmentSignedUrl } from '@/utils/attachmentUtils';

export const useAttachmentSignedUrl = (filePath: string | null) => {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!filePath) {
      setSignedUrl(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    getAttachmentSignedUrl(filePath)
      .then(url => {
        if (!cancelled) {
          setSignedUrl(url);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError('Erro ao carregar imagem');
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [filePath]);

  return { signedUrl, isLoading, error };
};
